import Legend from './Legend';
export { legendTypes } from './legend_funcs';

export default Legend;
